import axios from "axios";

export const Elastic = axios.create({
  baseURL:
    "https://9a1b2dfb64ce4b7694bb4e7eb1456e5b.us-east-1.aws.found.io:9243",
  auth: {
    username: "elastic",
    password: "IaauChg4QkUyuGbLoqvfebfO",
  },
});
